import { RouteConfig } from 'vue-router'

import RRunning, * as runningRouter from './RRunning'

const Layout = () => import('../views/Layout.vue')

const layoutRoute: RouteConfig = {
  path: '/university',
  name: 'tzy_university',
  component: Layout,
  redirect: RRunning[0],
  children: [...RRunning],
}

export default layoutRoute

export const routers = { runningRouter }
